import type { IFieldDefinition, Lang } from '@platform/core/types';

/**
 * Текст, від якого рахується ширина стовпця поля (прототип v4 MW: від `f.label` визначення — англійського підпису, а після перейменування
 * в конструкторі — від нового підпису): підпис злитого визначення мовою інтерфейсу, якщо він відрізняється від рядка пакета i18n
 * (`bundleText` — перейменування простором, ADR-023), інакше англійський підпис визначення, інакше показаний підпис (власні поля простору).
 * Чиста функція.
 */
export function fitLabelOf(field: IFieldDefinition, bundleText: string, lang: Lang, shown: string): string {
  const own = field.label[lang]?.trim();
  return own && own !== bundleText ? own : field.label.en?.trim() || shown;
}
